import { Toggle } from '@ixyberfree/ixybercomponents';
import { ButtonIcon } from 'components/button';
import { prefbase } from 'components/hmilib/hmiclientbase';
import Tables from 'components/modules/trends/GroupTrend/Tables/Tables';
import * as React from 'react';
import { useState } from 'react';
// import { Input } from 'reactstrap';
import styles from './BlockPage.module.css';
import AllTypesPage from './components/AllTypesPage/AllTypesPage';
import EditColumns from './components/EditColumns/EditColumns';

export interface IPropsBlockPage {
    selectData: any;
    addElement: Function;
    delElement: Function;
    changeSelectElement: Function;
    propTree?: any;
    propHeader?: any;
    changeInput?: (id: string, propName: string, value: any) => void;
}

interface IInputFieldProps {
    id: string;
    title: string;
    value: string;
    disabled: boolean;
    onChange: (newValue: string) => void;
}

const index = ({
    propTree,
    selectData,
    addElement,
    delElement,
    changeSelectElement,
    changeInput
}: IPropsBlockPage): JSX.Element => {
    const [enableAllElements, setEnableAllElements] = useState<boolean>(false);

    let tableHeader;
    const localStorageHeader = localStorage.getItem('tableHeader');

    if (localStorageHeader) {
        tableHeader = JSON.parse(localStorageHeader);
    } else {
        tableHeader = [
            { type: 'select', label: 'selected', width: '', idCol: 'select' },
            { type: 'text', label: 'Name', width: '200px', idCol: 'name' },
            { type: 'text', label: 'Description', width: '150px', idCol: 'description' },
            { type: 'text', label: 'ClassName', width: '200px', idCol: 'ClassName' },
            { type: 'text', label: 'Path', width: '200px', idCol: 'path' },
            { type: 'text', label: 'Shape', width: '150px', idCol: 'shape' },
            { type: 'text', label: 'SourceOut.address', width: '250px', idCol: 'sourceOut.address' },
            { type: 'text', label: 'SourceIn.address', width: '250px', idCol: 'sourceIn.address' }
        ];
    }

    return (
        <>
            <div style={{ margin: '10px 10px 0px 10px', display: 'flex', justifyContent: 'space-between' }}>
                <h3 style={{ margin: '0px' }}>{enableAllElements ? prefbase : selectData.path}</h3>
                <Toggle
                    label={'Все объекты'}
                    width="140px"
                    checked={enableAllElements}
                    onChange={() => setEnableAllElements((prev) => !prev)}
                />
            </div>
            <div style={{ margin: '10px', width: 'calc(100% - 20px)', height: 'calc(100% - 60px)' }}>
                {enableAllElements ? (
                    <AllTypesPage
                        propTree={propTree}
                        selectData={selectData}
                        addElement={addElement}
                        delElement={delElement}
                        propHeader={tableHeader}
                        changeSelectElement={changeSelectElement}
                        changeInput={changeInput}
                    />
                ) : (
                    <BlockPage
                        selectData={selectData}
                        addElement={addElement}
                        delElement={delElement}
                        propHeader={tableHeader}
                        changeSelectElement={changeSelectElement}
                        changeInput={changeInput}
                    />
                )}
            </div>
        </>
    );
};

export default index;

const BlockPage = ({
    selectData,
    addElement,
    delElement,
    changeSelectElement,
    propHeader,
    changeInput
}: IPropsBlockPage): JSX.Element => {
    const [dataTable, setDataTable] = React.useState<any[]>([]);
    const [checker, setChecker] = React.useState<string[]>([]);
    const [checkedID, setCheckedID] = React.useState<string[]>([]);
    const [objIdsArr, setObjIdsArr] = React.useState<string[]>([]);
    const [settingsTable, setSettingsTable] = React.useState<boolean>(false);
    const [mainTableVisible, setMainTableVisible] = React.useState<boolean>(true);

    const [optionFilter, setOptionFilter] = React.useState<any[]>([
        { action: false, param: [], selParam: [], type: 'text' },
        { action: true, param: [], selParam: [], type: 'text' },
        { action: true, param: [], selParam: [], type: 'text' },
        { action: true, param: [], selParam: [], type: 'text' },
        { action: true, param: [], selParam: [], type: 'text' },
        { action: true, param: [], selParam: [], type: 'text' }
    ]);

    const [tableHeader, setTableHeader] = React.useState<any[]>(propHeader);

    const renderRow = (selectedDataFull: any) => {
        if (selectedDataFull) {
            let arr: any[] = [];
            const idArr: string[] = [];

            Object.entries(selectedDataFull).forEach(([key, value]) => {
                if (typeof value === 'object' && value !== null && key != 'bindinglist' && key != 'parent') {
                    Object.entries(value).forEach(([key, value]) => {
                        let inputFields: any = {};
                        idArr.push(value.id);
                        inputFields[key] = CreateInputForMainTable(value);
                        if (inputFields[key]) {
                            arr.push({ ...inputFields[key] });
                        }
                    });
                }
            });

            arr.sort(function (a, b) {
                if (a.ClassName && b.ClassName) {
                    if (b.ClassName.props.defaultValue < a.ClassName.props.defaultValue) {
                        return 1;
                    }
                    if (b.ClassName.props.defaultValue > a.ClassName.props.defaultValue) {
                        return -1;
                    }
                }
                if (a.name.props.defaultValue < b.name.props.defaultValue) {
                    return -1;
                }
                if (a.name.props.defaultValue > b.name.props.defaultValue) {
                    return 1;
                }

                return 0;
            });

            setObjIdsArr(idArr);
            setDataTable(arr);
        }
    };

    React.useEffect(() => {
        renderRow(selectData);
    }, [selectData]);

    function CreateInputForMainTable(obj: any) {
        if (obj.id !== undefined) {
            const inputFields: Record<string, JSX.Element> = {};
            const blockParameters = ['ClassName', 'path'];
            const specialKeys = {
                sourceIn: 'address',
                sourceOut: 'address',
                location: 'location'
            };

            if (obj.sourceIn && obj.sourceIn.refinterface?.rpath !== undefined) {
                obj['sourceIn.refinterface.rpath'] = obj.sourceIn.refinterface.rpath;
            }
            if (obj.sourceOut && obj.sourceOut.refinterface?.rpath !== undefined) {
                obj['sourceOut.refinterface.rpath'] = obj.sourceOut.refinterface.rpath;
            }

            Object.entries(obj).forEach(([key, value]: [string, any]) => {
                const isDisabled = blockParameters.includes(key);
                const specialKey = key in specialKeys ? specialKeys[key as keyof typeof specialKeys] : undefined;
                const fieldKey = specialKey ? `${key}.${specialKey}` : key;
                const fieldValue = specialKey ? value[specialKey] : value;
                const inputId = `${fieldKey}-${obj.id}`;
                const id = specialKey ? value.id : obj.id;

                inputFields[fieldKey] = (
                    <InputField
                        key={inputId}
                        id={inputId}
                        title={String(fieldValue) || ''}
                        value={fieldValue as string}
                        disabled={isDisabled}
                        onChange={(newValue) => changeInput && changeInput(id, specialKey || key, newValue)}
                    />
                );
            });
            return inputFields;
        }
        return undefined;
    }

    const InputField = ({ id, title, value, disabled, onChange }: IInputFieldProps) => (
        <input
            id={id}
            type="text"
            title={title}
            defaultValue={value}
            onClick={(e: any) => e.stopPropagation()}
            style={{
                border: 'none',
                fontSize: '14px',
                outline: 'none',
                width: '100%',
                overflow: 'hidden',
                textOverflow: disabled ? 'clip' : 'ellipsis',
                background: 'none'
            }}
            disabled={disabled}
            onBlur={(event: any) => onChange(event.target.value)}
        />
    );

    const CheckItem = (item: any, check: boolean) => {
        let index = dataTable.findIndex((f) => f.id == item.id);
        if (index > -1) {
            let checker_t = [...checker];
            if (check && checker_t.findIndex((f) => f == dataTable[index].id) == -1)
                checker_t.push(dataTable[index].id);
            else checker_t = checker_t.filter((f) => f != dataTable[index].id);
            setChecker(checker_t);
        }
        let tempIds: string[] = checkedID;
        if (item.id.key) {
            for (let id of objIdsArr) {
                if ((item.id.key as string).includes(id)) {
                    if (check) {
                        tempIds.push(id);
                    } else {
                        tempIds = tempIds.filter((i) => !i.includes(id));
                    }
                    break;
                }
            }
        }
        setCheckedID(tempIds);
    };

    const CheckItemAll = (check: boolean, dataId: string[]) => {
        let checker_t: string[] = [];
        let checkedID: string[] = [];
        if (check) {
            checker_t = dataId;
            checkedID = objIdsArr;
        }

        setChecker(checker_t);
        setCheckedID(checkedID);
    };

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'right', padding: '5px' }}>
                <ButtonIcon
                    title="Добавить/Убрать столбцы"
                    onClick={() => setSettingsTable(true)}
                    src="/ixyber/vision/static/images/trends/main/Show_menu.svg"
                />
                <div className={styles.iconBut}>
                    <div
                        title="Добавить"
                        className={styles.addBlock}
                        style={{ padding: '2.5px' }}
                        onClick={() => {
                            addElement();
                        }}></div>
                </div>
                <div className={styles.iconBut}>
                    <div
                        title="Удалить"
                        className={styles.delBlocks}
                        style={{ padding: '2.5px' }}
                        onClick={() => {
                            delElement(checkedID);
                        }}></div>
                </div>
            </div>
            <div className={styles.BlockPageTable}>
                <Tables
                    key={'tableBlockPage'}
                    width="max-content"
                    actionSort={true}
                    checked={checker}
                    allChecked={true}
                    actionFilter={true}
                    isFullRender={false}
                    header={tableHeader}
                    onCheck={(item, check) => {
                        CheckItem(item, check);
                    }}
                    onAllCheck={(check: boolean, dataId: string[]) => {
                        CheckItemAll(check, dataId);
                    }}
                    onDblClickItem={(item: any, col: string) => {
                        changeSelectElement(item.id);
                    }}
                    data={dataTable}
                    onFilter={(elem) => {}}
                />
            </div>
            {settingsTable && (
                <EditColumns
                    onClose={() => setSettingsTable(false)}
                    onSave={(selectedColumns) => {
                        setTableHeader(selectedColumns);
                    }}
                    selectData={selectData}
                    tableHeader={tableHeader}
                />
            )}
        </>
    );
};
